import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-pagebar',
  templateUrl: './pagebar.component.html',
  styleUrls: ['./pagebar.component.less']
})
export class PagebarComponent implements OnInit {
  public pageName = '';

  constructor(private router: Router, private utils: UtilsService) { }

  ngOnInit() {
    this.getPageName();
  }

  // returns the page name - used on template
  public getPageName() {
    const pageName = this.router.url.split('/dashboard/')[1].replace('-', ' ');
    this.pageName = this.utils.uppercaseFirstLetter(pageName);
  }
}
